var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.getComponent,_vm._b({tag:"component",attrs:{"buttonWidth":_vm.buttonWidth},on:{"files-upload":_setup.onFilesUpload,"file-delete":_setup.onFileDelete,"file-download":_setup.onFileDownload,"file-error":_setup.onFileError}},'component',_setup.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }